import { t } from '../../../common/i18n.js'
import { Language } from '../../../common/types/i18n.js'
import { getLevelProgressPercent } from '../../../common/utils/level-utils.js'

/**
 * Generate a dynamic subtitle message that praises the user's progress and lists their leaderboard rank.
 * The sentences live in i18n (`playtime.levelProgress.subtitle*`); this only picks the band.
 */
export const getLevelProgressSubtitle = (
    score: number,
    level: number,
    nextThreshold: number,
    rank: number,
    lang: Language,
): string => {
    const clampedProgress = getLevelProgressPercent(score, nextThreshold)
    const s = t.playtime.levelProgress

    if (clampedProgress < 30) return s.subtitleStart(rank)(lang)
    if (clampedProgress < 60) return s.subtitleHalfway(rank)(lang)
    if (clampedProgress < 90) return s.subtitleNear(rank)(lang)
    return s.subtitleVerge(rank)(lang)
}

/**
 * Hover cards near the table bottom open upward so they stay inside the
 * table's own bounds — .leaderboard-table's overflow would clip them below
 * the last rows. Never flips within the first 5 rows (no headroom above).
 */
export const getHoverCardPlacement = (index: number, total: number): 'above' | 'below' =>
    index >= 5 && index >= total - 5 ? 'above' : 'below'
